import React, { Fragment } from "react";
import { Container, Divider, FaIcon, Heading } from "@bilar/ui";
import {
	getClassifiedsBaseQuery,
	vehicleDataConverter,
	VehiclesListAll,
} from "@bilar/features";
import {
	collection,
	getDocs,
	getFirestore,
	QuerySnapshot,
} from "firebase/firestore";
import {
	GetStaticProps,
	GetStaticPropsContext,
	GetStaticPropsResult,
} from "next";
import initFirebase from "@bilar/firebase/initFirebase";
import { collections, getConfig } from "@bilar/config";
import { getBasePagePropsData } from "@bilar/pages-common";
import { BasePageProps, useAppTranslation } from "@bilar/common";
import { ClassifiedVehicle } from "@bilar/models";
import { faCars } from "@fortawesome/pro-solid-svg-icons";
import Head from "next/head";

type VehiclePageProps = {
	ads: ClassifiedVehicle[];
	lastDocId: string;
} & BasePageProps;

const numberOfDocuments = 12;

const VehiclesPage = (props: VehiclePageProps) => {
	const { t } = useAppTranslation();

	return (
		<Fragment>
			<Head>
				<title>{`Bílar.is - ${t("titleTag")}`}</title>
			</Head>

			{/*<RouteTransition>*/}
			<Container>
				<Heading as="h1" size="large">
					<FaIcon icon={faCars} mr={4} />
					{t("allVehicles")}
				</Heading>
				<Divider mb={4} />
				<VehiclesListAll initialData={props.ads} lastDocId={props.lastDocId} />
			</Container>
			{/*</RouteTransition>*/}
		</Fragment>
	);
};

export const getStaticProps: GetStaticProps<VehiclePageProps> = async (
	ctx: GetStaticPropsContext,
): Promise<GetStaticPropsResult<VehiclePageProps>> => {
	const firebaseApp = initFirebase();
	const db = getFirestore(firebaseApp);
	const adsRef = collection(db, collections.CLASSIFIEDS).withConverter(
		vehicleDataConverter,
	);
	const config = getConfig();
	const classifiedsQuery = getClassifiedsBaseQuery(
		adsRef,
		config.public.classifiedsPerPage,
	);

	//let data: ClassifiedVehicle[] = [];

	const snapshot: QuerySnapshot<ClassifiedVehicle> = await getDocs(
		classifiedsQuery,
	);

	const lastDocId = snapshot.docs[snapshot.docs.length - 1].id;
	const data: ClassifiedVehicle[] = snapshot.docs.map((doc) => {
		let docData = doc.data();
		// docData.createdAt = JSON.stringify(docData.createdAt?.toDate());
		// docData.updatedAt = JSON.stringify(docData.updatedAt?.toDate());

		return docData;
	});

	// Get Locale and common translations
	const baseProps = await getBasePagePropsData(ctx);

	return {
		props: {
			ads: data,
			lastDocId: lastDocId,
			...baseProps,
		},
		// we will attempt to re-generate the page:
		// - when a request comes in
		// - at most once every second
		revalidate: 60,
	};
};

export default VehiclesPage;
